import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageConst } from '~common/config/constants';
import { Observable } from 'rxjs'
import { Student, DataTableRequest, DataTableResponse } from '~common/model/master'
import { environment } from '../../../environments/environment';

export class BaseService {
  public isProcessing: boolean = false
  constructor(private client: HttpClient) { }

  protected saveServerIdenity(serverName: string, serverPort:number, username: string) : void {
    // localStorage.setItem(LocalStorageConst.ServerName, serverName);
    // localStorage.setItem(LocalStorageConst.ServerPort, serverPort.toString());
    localStorage.setItem(LocalStorageConst.Username, username);
  }

  // serverHost : string = `${this.getServerIdentity().serverName}:${this.getServerIdentity().serverPort}/${this.getServerIdentity().prefix}`
  serverHost : string = environment.apiUrl

  public getServerIdentity(): any {
    return {
      serverName: environment.serverHost,
      serverPort: environment.serverPort,
      prefix: environment.prefix,
      apiUrl: environment.apiUrl,
      username: localStorage.getItem(LocalStorageConst.Username)
    };
  }

  protected async get(url: string): Promise<any> {
    let result = null;
    this.isProcessing = true
    await this.client
      .get(encodeURI(`${this.serverHost}/${url}`))
      .toPromise()
      .then(response => {
        result = response;
        this.isProcessing = false
      }).catch(err => {
        result = { error: err as Response };
        this.isProcessing = false
      });

    return result;
  }

  protected async getWithParameter(url: string, parameter: any): Promise<any> {
    let result = null;
    this.isProcessing = true
    await this.client
      .get(encodeURI(`${this.serverHost}/${url}`), {params : parameter})
      .toPromise()
      .then(response => {
        result = response;
        this.isProcessing = false
      }).catch(err => {
        result = { error: err as Response };
        this.isProcessing = false
      });

    return result;
  }

  protected async post(url: string, body: any): Promise<any> {
    let result = null;
    this.isProcessing = true
    await this.client
      .post(encodeURI(`${this.serverHost}/${url}`), body,{ headers: new HttpHeaders({ timeout: `${10000000}` }) })
      .toPromise()
      .then(response => {
        result = response;
        this.isProcessing = false
      })
      .catch(err => {
        result = { error: err as Response };
        this.isProcessing = false
      });

    return result;
  }

  protected async put(url: string, body: any): Promise<any> {
    let result = null;
    this.isProcessing = true
    await this.client
      .put(encodeURI(`${this.serverHost}/${url}`), body)
      .toPromise()
      .then(response => {
        result = response;
        this.isProcessing = false
      })
      .catch(err => {
        result = { error: err as Response };
        this.isProcessing = false
      });

    return result;
  }

  protected async patch(url: string, body: any): Promise<any> {
    let result = null;
    this.isProcessing = true
    await this.client
      .patch(encodeURI(`${this.serverHost}/${url}`), body)
      .toPromise()
      .then(response => {
        result = response;
        this.isProcessing = false
      })
      .catch(err => {
        result = { error: err as Response };
        this.isProcessing = false
      });

    return result;
  }

  protected async delete(url: string, id:string): Promise<any> {
    let result = null;
    this.isProcessing = true
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        id: id
      }
    }
    await this.client
      .delete(encodeURI(`${this.serverHost}/${url}`),options)
      .toPromise()
      .then(response => {
        result = response;
        this.isProcessing = false
      })
      .catch(err => {
        result = { error: err as Response };
        this.isProcessing = false
      });

    return result;
  }

  protected ajaxRequest(url: string, filters: any): Observable<DataTableResponse>{
    let start = parseInt(filters.start)
    let length = parseInt(filters.length)
    filters.start = (start * length) - length
    return  this.client.post<DataTableResponse>(`${this.serverHost}/${url}`, filters)
  }

  protected getFile(url: string, filters: any){
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    this.isProcessing = true
    const result = this.client.post(`${this.serverHost}/${url}`, filters, httpOptions)
    this.isProcessing = false
    return result
  }
}
